import slidesARCAND from './slides_Arcand';
import { featuresARCAND } from './features_Arcand';
import { ProjectType } from '../../Constants';
import { textARCAND } from './text_Arcand';

export const ARCANDdata = {
    fr: {
        id: 1,
        name: 'Siège social de SIMDEV',
        content: textARCAND.fr,
        yearBuilt: 2023,
        address: "2425 Rue Arcand, Montréal, QC H1N 3C2",
        city: "Montréal",
        brand: "simdev",
        projectPage: "hq",
        website: "https://www.simdev.ca",
        category: ProjectType.Commercial,
        images: slidesARCAND,
        features: featuresARCAND.fr
    },
    en: {
        id: 1,
        name: 'SIMDEV Head Office',
        content: textARCAND.en,
        yearBuilt: 2023,
        address: "2425 Rue Arcand, Montréal, QC H1N 3C2",
        city: "Montréal",
        brand: "simdev",
        projectPage: "hq",
        website: "https://www.simdev.ca",
        category: ProjectType.Commercial,
        images: slidesARCAND,
        features: featuresARCAND.en
    }
    
}